export class archivedUrl {
    ARCHIVED_ORGANIZERS_URL = "org/v1/archived-organizer/all[?ClientID][&ClientName][&TaxPayerEmail][&SpouseEmail][&ArchivedBy][&TaxYear][&BatchName][&ERO][&DeliveredAfter][&OrganizerReminder][&SigningReminder][&SignatureStatus][&OrganizerStatus][&SourceDocumentStatus][&SortBy][&SortOrder][&PageNo][&PageSize]";
    DELETE_ORGANIZERS_URL = "org/v1/archived-organizer/";
    MOVE_TO_DELIVERED = "org/v1/archived-organizer/move-to-delivered";
    RESEND_ACCESS_LINK = "org/v1/archived-organizer/resend-access-link";
    SIGNER_DETAILS = "org/v1/archived-organizer/{organizerId}/signer-info"
}